// theme-sources/js/controllers/theme.controller.js

import { logger } from "../core/logger";

function initAnchorScroll() {
  document
    .querySelectorAll('a[href^="#"]:not([href="#"])')
    .forEach((anchor) => {
      anchor.addEventListener("click", (e) => {
        const target = document.querySelector(anchor.hash);

        if (!target) return;

        e.preventDefault();

        window.scrollTo({
          top: target.offsetTop - 80,
          behavior: "smooth",
        });
      });
    });
}

export function initVideoPlay(root = document) {
  const players = root.querySelectorAll(".video-play");
  if (!players.length) return;

  logger.info("VideoPlay", "init");

  const playingVideos = [];

  players.forEach((player) => {
    const wrapper = player.parentNode;
    const video = wrapper.querySelector("video");
    const card = video?.closest('[data-card="recto-verso"]');

    if (!video) return;

    const showPlayButton = () => {
      video.controls = false;
      player.style.zIndex = "10";
      card?.classList.remove("is-video-playing");

      const index = playingVideos.indexOf(video);
      if (index !== -1) playingVideos.splice(index, 1);
    };

    const hidePlayButton = () => {
      player.style.zIndex = "-1";
      video.controls = true;
      card?.classList.add("is-video-playing");
    };

    player.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      playingVideos.forEach((v) => {
        if (v !== video) v.pause();
      });

      hidePlayButton();
      video.play();

      if (!playingVideos.includes(video)) {
        playingVideos.push(video);
      }
    });

    video.addEventListener("play", () => {
      playingVideos.forEach((v) => {
        if (v !== video) v.pause();
      });

      hidePlayButton();

      if (!playingVideos.includes(video)) {
        playingVideos.push(video);
      }
    });

    video.addEventListener("pause", () => {
      if (video.ended) return;
      showPlayButton();
    });

    video.addEventListener("ended", () => {
      showPlayButton();
      video.load();
    });
  });
}

function openCartFromCookie() {
  if (!document.cookie.includes("open_cart=1")) return;
  document.querySelector("ziggy-drawer#cart")?.open();
  document.cookie = "open_cart=; max-age=0; path=/";
}

export function initThemeController() {
  logger.info("ThemeController", "init");

  openCartFromCookie();

  initAnchorScroll();
  initVideoPlay();
}
